"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRUNCATE_ABOVE_VALUE = exports.MIN_PAGES_TO_SHOW = exports.DEFAULT_PAGE_TO_SHOW_VALUE = void 0;
const TRUNCATE_ABOVE_VALUE = exports.TRUNCATE_ABOVE_VALUE = 4;
const MIN_PAGES_TO_SHOW = exports.MIN_PAGES_TO_SHOW = 3;
const DEFAULT_PAGE_TO_SHOW_VALUE = exports.DEFAULT_PAGE_TO_SHOW_VALUE = 1;